import { render, staticRenderFns } from "./Allocation-detail.vue?vue&type=template&id=01e32e5a"
import script from "./Allocation-detail.vue?vue&type=script&lang=js"
export * from "./Allocation-detail.vue?vue&type=script&lang=js"
import style0 from "./Allocation-detail.vue?vue&type=style&index=0&id=01e32e5a&prod&lang=css"
import style1 from "./Allocation-detail.vue?vue&type=style&index=1&id=01e32e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports